<template>
    <b-dropdown
        id="dropdown-form"
        :text="textoBotao != null ? textoBotao : 'Exibir / Ocultar colunas'"
        ref="dropdown"
        variant="outline-primary"
        :class="cssClass"
        >
        <template v-for="(field,i) in fields">
            <template v-if="field.key != 'selecionar'">
                <b-dropdown-item-button @click="$emit('toggleColuna', i)" :key="i">
                    <label><input type="checkbox" ref="chk" :checked="showColumn(i)" /> {{ field.label }}</label>
                </b-dropdown-item-button>
            </template>
        </template>
    </b-dropdown>
</template>

<script>
export default {
    props: ['fields', 'showColunms', 'textoBotao', 'cssClass'],
    methods: {
        showColumn(i) {
            return this.showColunms.includes(i) ? true : false
        },
    }

}
</script>

<style>
  .scroll .dropdown-menu {
    max-height: 50vh;
    overflow-y: auto;
  }
</style>
